// extracted by mini-css-extract-plugin
export default {"Button__container":"Button-styles__Button__container__ELDHe","Button--wide":"Button-styles__Button--wide__M5cPl"};